import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdgeMillingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "edge_milling-sm" }), /* @__PURE__ */ _jsxs("g", {
		id: "Layer_2",
		"data-name": "Layer 2",
		children: [
			/* @__PURE__ */ _jsx("polygon", {
				className: "icon-white",
				points: "75.68 44.72 70.51 47.73 65.29 38.73 65.29 38.72 49.87 29.82 8.56 53.67 8.56 65.59 24.15 74.59 29.35 71.63 34.54 80.59 50.13 89.59 91.44 65.75 91.44 53.82 75.68 44.72"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M92,52.78h0l-15.76-9.1a1.24,1.24,0,0,0-1.21,0l-4.13,2.41L66.37,38.2h0A1.56,1.56,0,0,0,66.2,38l0-.05a1.24,1.24,0,0,0-.22-.18h0l0,0-15.42-8.9a1.22,1.22,0,0,0-1.2,0L8,52.63a1.21,1.21,0,0,0-.6,1V65.59a1.2,1.2,0,0,0,.6,1l15.59,9a1.15,1.15,0,0,0,.6.16,1.2,1.2,0,0,0,.59-.15l4.17-2.38,4.59,7.93a1.16,1.16,0,0,0,.44.44l15.59,9a.85.85,0,0,0,.22.09l.07,0a1.06,1.06,0,0,0,.31,0,1.34,1.34,0,0,0,.4-.07,1.21,1.21,0,0,0,.2-.09L92,66.79a1.22,1.22,0,0,0,.6-1V53.82A1.2,1.2,0,0,0,92,52.78ZM51.33,87.51V78.36L90.24,55.9v9.15Zm-28.06-24,4.43,7.64-3.55,2L9.76,64.9V55.75ZM64.41,39.6l4.46,7.7L49.51,58.57,33.94,67.63,29.79,70l-4.6-7.93L25.14,62l0,0-.1-.12,0,0,0,0-.16-.12,0,0L11,53.67,49.87,31.21Zm11.27,6.51L89,53.82,50.13,76.28l-13.2-7.61,34.18-19.9h0ZM34.54,70.05l14.39,8.31v9.15l-13.51-7.8L31,72.08Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M76.72,44.12a1.22,1.22,0,0,0-.74-.56,1.21,1.21,0,0,0-.91.12l-4.13,2.41-4.62-8a1.18,1.18,0,0,0-.37-.4l0,0a1.17,1.17,0,0,0-.28-.13,1.88,1.88,0,0,0-.33,0h0a.71.71,0,0,0-.2,0h0l-.18,0-.08,0-.08,0-1.31.77a1.18,1.18,0,0,0-.56.73,1.21,1.21,0,0,0,.12.91,1.22,1.22,0,0,0,1.64.43l.28-.16,4,6.94L34,67.63,29.79,70l-4-6.89,2.28-1.33a1.2,1.2,0,0,0,.44-1.64,1.22,1.22,0,0,0-.74-.56,1.21,1.21,0,0,0-.91.12l-3.31,1.93a1,1,0,0,0-.21.16.71.71,0,0,0-.17.2.86.86,0,0,0-.1.16.34.34,0,0,0,0,.08.69.69,0,0,0-.05.13.87.87,0,0,0,0,.1.59.59,0,0,0,0,.13v.09a.61.61,0,0,0,0,.14.51.51,0,0,0,0,.09l0,.14a.34.34,0,0,1,0,.08.61.61,0,0,0,.07.14l4.59,7.92-4.14,2.36a1.23,1.23,0,0,0-.57.73,1.21,1.21,0,0,0,.12.91,1.23,1.23,0,0,0,1.63.45l4.17-2.38,4.59,7.93a1.21,1.21,0,0,0,1,.6,1.15,1.15,0,0,0,.6-.16A1.21,1.21,0,0,0,35.58,80L31,72.08l4.15-2.37L76.28,45.76a1.18,1.18,0,0,0,.56-.73A1.2,1.2,0,0,0,76.72,44.12ZM64.89,37.85ZM23.21,62.49Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M44.06,52.28a1.25,1.25,0,0,0,.6-.16L48,50.18a1.19,1.19,0,0,0,.43-1.64,1.21,1.21,0,0,0-1.64-.43L43.46,50a1.18,1.18,0,0,0-.56.73,1.2,1.2,0,0,0,1.16,1.51Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M50.7,48.42a1.16,1.16,0,0,0,.6-.17l3.32-1.93a1.2,1.2,0,0,0-1.21-2.07l-3.32,1.93a1.2,1.2,0,0,0,.61,2.24Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M57.33,44.55a1.21,1.21,0,0,0,.61-.16l3.31-1.93a1.18,1.18,0,0,0,.56-.73,1.2,1.2,0,0,0-1.76-1.35l-3.32,1.93a1.22,1.22,0,0,0-.56.74,1.17,1.17,0,0,0,.13.91A1.21,1.21,0,0,0,57.33,44.55Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M37.42,56.14A1.21,1.21,0,0,0,38,56l3.31-1.93a1.18,1.18,0,0,0,.56-.73A1.2,1.2,0,0,0,40.14,52l-3.32,1.94a1.19,1.19,0,0,0-.43,1.64A1.21,1.21,0,0,0,37.42,56.14Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M30.79,60a1.16,1.16,0,0,0,.6-.17l3.32-1.93a1.21,1.21,0,0,0,.43-1.64,1.2,1.2,0,0,0-1.64-.43l-3.32,1.93a1.2,1.2,0,0,0-.55.73,1.16,1.16,0,0,0,.12.91A1.2,1.2,0,0,0,30.79,60Z"
			})
		]
	})]
});
export default SvgEdgeMillingSm;
